<template>
  <div>
    <div class="container mt-4 mb-4">
      <form>
	<div class="card">
          <div class="card-body">
            <div class="form-group row">
              <div class="container">
		<div class="row">
		  <div class="col-3">
                    <div class="d-flex align-items-center justify-content-end" style="height:100%">Product Name</div>
		  </div>
		  <div class="col-6">
		    <div class="p-2 bd-highlight">
                      <select class="custom-select form-control col-8" id="select2" v-model="product_id" @change="selectProduct">
			<option selected></option>
			<option v-for="option in product_list" :value="option.product_id">{{ option.product_name }}</option>
                      </select>
		    </div>
		  </div>
		  <div class="col-3">
                    <div class="d-flex align-items-center justify-content-center" style="height:100%">
		      <button @click="generate" type="button" class="bluebtn2" v-bind:disabled="disabled_gen">Generate</button>
                    </div>
		  </div>
		</div>
		<div class="row">
		  <div class="col-3">
                    <div class="d-flex align-items-center justify-content-end" style="height:100%">Number of generations</div>
		  </div>
		  <div class="col-6">
		    <div class="p-2 bd-highlight"><input type="number" class="form-control col-6" id="dateinstall1" name="dateinstall1" placeholder="1000" size="8" maxlength="" v-model="count"></div>
		  </div>
		  <div class="col-3">
                    <div class="d-flex align-items-center justify-content-center" style="height:100%">
		      <router-link to="./menu2.html">
			<div class="greenbtn2">Close</div>
		      </router-link>
.                    </div>
		  </div>
		</div>
              </div>

            </div>
	  </div>
	</div>
      </form>
    </div>
    <div class="container">
      <div class="row">
	<div class="col-12">
	  <div class="d-flex align-items-center justify-content-center">
	    <EasyDataTable
	      table-class-name="custom"
	      id="code-tab"
	      v-model:server-options="serverOptions"
	      :server-items-length="serverItemsLength"
	      :loading="loading"
	      :headers="headers"
	      :items="items"
	      :rowsItems=[20,50,100]
	      :mustSort=true
	      border-cell
	      alternating
	      />
	  </div>
	</div>
      </div>
    </div>
    <p class="linespace20"></p>
  </div>

  <ErrorDialog />
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { checkMaintenance, getProductList, getSoftwareTypeList, getTargetOSList, getVersionInfo, addVersionInfo, updateVersionInfo, deleteVersionInfo, getActivationCodeList, generateActivationCode, downloadActivationCode } from '../server';
import { error } from './ErrorDialog.vue';

checkMaintenance();

const headers = [
    {
	text: 'Activation Code',
	value: 'activation_code',
	sortable: true
    },
    {
	text: 'License Type',
	value: 'license_type_name'
    },
    {
	text: 'Created Date (JST)',
	value: 'create_date',
	sortable: true
    },
    {
	text: 'Date of Issue (JST)',
	value: 'publish_date',
	sortable: true
    },
    {
	text: 'Num of Installations',
	value: 'install_count',
	sortable: true
    },
    {
	text: 'Last Modified (JST)',
	value: 'update_date',
	sortable: true
    }
];

const product_list = ref([]);
const product_id = ref(0);
const count = ref(0);
const disabled_gen = ref(false);
let   gen_id = 0;

const loadProductFromServer = async() => {
    try {
	let res = await getProductList({});
	product_list.value = res.serverCurrentPageItems;
    }
    catch(e) {
	console.log(e)
    }
};

loadProductFromServer();

const items = ref([]);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
    page: 1,
    rowsPerPage: 20,
    sortBy: 'activation_code',
    sortType: 'asc'
});

const loadFromServer = async() => {
    loading.value = true;
    try {
	let opts = Object.assign(
    	    {gen_id},
    	    serverOptions.value);
	let res = await getActivationCodeList(opts);
	items.value = res.serverCurrentPageItems;
	serverItemsLength.value = res.serverTotalItemsLength;
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
};

loadFromServer();

watch(serverOptions, (value) => {loadFromServer(); }, { deep: true });
watch(product_id, (value) => {loadFromServer(); });

const generate = async() => {
    if (!product_id.value) {
       error('select product');
       return;
    }
    if (!count.value || count.value <= 0) {
       error('input count');
       return;
    }
    try {
	disabled_gen.value = true;
    	let result = await generateActivationCode(product_id.value,count.value);
	gen_id = result.gen_id;
	downloadActivationCode(result.name, result.file);
    }
    catch(e) {
	console.log(e)
    }
    finally {
	disabled_gen.value = false;
    }
    await loadFromServer();
};

</script>

<style scoped>
.app {
  font-size: 40px;
    color: blue;
}
#code-tab {
    width: 100%;
}
.custom {
    --easy-table-header-background-color: #9df5bc;
}
</style>
